import type { Color } from '@onefootprint/design-tokens';
import { IcoCheck16, IcoClose16, IcoDotSmall16, IcoInfo16, type Icon, IcoWarning16 } from '@onefootprint/icons';
import type { UserTimelineEventWatchlistCheck, WatchlistCheckStatusKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import EventBodyEntry from '../event-body-entry';

type WatchlistCheckEventBodyProps = {
  data: UserTimelineEventWatchlistCheck['data'];
  lineHeight?: 'default' | 'large';
  showIcons?: boolean;
};

const textColors: Record<WatchlistCheckStatusKind, Color> = {
  pass: 'success',
  fail: 'error',
  not_needed: 'primary',
  error: 'warning',
  pending: 'primary',
  repeated_hits: 'primary',
  initial_kyc_record: 'primary',
};

const statusIcons: Record<WatchlistCheckStatusKind, Icon> = {
  pass: IcoCheck16,
  fail: IcoWarning16,
  not_needed: IcoInfo16,
  error: IcoClose16,
  pending: IcoInfo16,
  repeated_hits: IcoInfo16,
  initial_kyc_record: IcoInfo16,
};

const WatchlistCheckEventBody = ({ data, lineHeight = 'large', showIcons }: WatchlistCheckEventBodyProps) => {
  const { t } = useTranslation('entity-details', {
    keyPrefix: 'auditTrail.timeline.watchlistCheckEvent',
  });
  const { status } = data;
  const color = textColors[status];
  const iconComponent = showIcons ? statusIcons[status] : IcoDotSmall16;
  const statusStr = t($ => $.status[status]) as string;

  return (
    <EventBodyEntry
      iconComponent={iconComponent}
      iconColor={color}
      lineHeight={lineHeight}
      content={
        <div className="flex items-center justify-start gap-1">
          <span className={`text-body-2 mr-0.5 text-${color}`}>{statusStr}</span>
        </div>
      }
      testID="watchlist-check-event-body"
    />
  );
};

export default WatchlistCheckEventBody;
